import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { patchUser, selectUser, useAppDispatch } from '../../../store';
import { useAppConfiguration } from '../../shared/hook/useAppConfiguration';
import LocalStorage from '../../../services/LocalStorage';
import Toast from '../../shared/toast';
import RecommendationEmpty, {
  RECOMMENDATION_EMPTY_BOX,
} from '../../components/recommendation-empty';
import { ToastType } from '../../shared/toast/interface';
import { addToastInfo } from '../../../store/common';

const ToastsSection = () => {
  const { t } = useTranslation();
  const { user } = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const { showDismissRecommendations } = useAppConfiguration();
  const [showNewsletterToast, setShowNewsletterToast] = useState(false);

  useEffect(() => {
    if (user) {
      setShowNewsletterToast(
        !user?.marketingReminderDismissed && !user?.marketingConsent,
      );
    }
  }, [user]);

  const onDissmissMarketingToast = () => {
    dispatch(patchUser({ marketingReminderDismissed: true }));
    setShowNewsletterToast(false);
  };

  const onSignupMarketingToast = () => {
    dispatch(
      patchUser({ marketingReminderDismissed: true, marketingConsent: true }),
    );

    dispatch(
      addToastInfo({
        toastInfo: {
          open: true,
          type: 'success',
          content: t(
            'v2.global.snackbar_label_getNewsletterUpdates_subscribed',
          ),
        },
      }),
    );
    setShowNewsletterToast(false);
  };

  return (
    <>
      {!user?.marketingReminderDismissed && !user?.marketingConsent && (
        <Toast
          type={ToastType.REMINDER}
          showToast={showNewsletterToast}
          text={t('v2.global.alert_subscribeToNewsletter_label_body')}
          onConfirm={() => onSignupMarketingToast()}
          onDismiss={() => onDissmissMarketingToast()}
        />
      )}
      {showDismissRecommendations &&
        !LocalStorage.getItem(RECOMMENDATION_EMPTY_BOX) && (
          <RecommendationEmpty />
        )}
    </>
  );
};

export default ToastsSection;
